import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class TvNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        type: PropTypes.number,
    };

    render() {
        const { content, type } = this.props;

        return (
            <div className={styles.leftNav}>
                <div className={styles.webLogo} />
                {content.map((item, index) => {
                    return (
                        <div className={styles.nav_img} key={index}>
                            <img
                                src={type === index ? item.src_active : item.src}
                                onClick={_ => {
                                    window.location.href = item.url;
                                }}
                            />
                        </div>
                    );
                })}
                <div className={styles.navBg} />
            </div>
        );
    }
}

export default errorBoundary(TvNav);
